var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _g, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _g2, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _g3, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _g4, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _g5, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _g6, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 133,
    height: 108,
    viewBox: "0 0 133 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93.2196 33.0961C90.9147 35.3992 87.7562 36.8493 84.2562 36.8493C77.2562 36.8493 71.622 31.2195 71.622 24.225C71.622 17.2305 77.2562 11.6007 84.2562 11.6007C87.3294 11.6007 90.2318 12.7096 92.3659 14.5862H99.622C99.3659 14.1597 99.1099 13.8185 98.8538 13.392C99.9635 11.6007 101.159 9.21232 101.329 6.99454L98.5123 4.52086C96.4635 4.86206 94.244 6.56804 92.622 8.01813C91.3416 7.33574 89.8903 6.82394 88.4391 6.48274C88.0977 4.43556 87.4147 1.79128 86.1342 0H82.3781C81.0977 1.53539 80.5001 4.35026 80.1586 6.48274C79.0489 6.73864 77.9391 7.07984 76.9147 7.59164C75.3781 6.14155 73.3294 4.43556 71.1952 3.83847L68.0367 6.14155C67.9513 8.18873 69.0611 10.7477 70.1708 12.6243C69.2318 13.7332 68.3781 15.0127 67.7806 16.3775C65.6464 16.2069 63.0001 16.2922 60.9513 17.2305L60.0977 20.8983C61.3781 22.519 63.8538 23.7132 65.9879 24.4809C65.9879 26.0163 66.244 27.4664 66.5855 28.9165C64.8781 30.1959 62.9147 31.9872 61.8903 33.9491L63.5977 37.2758C65.6464 37.7023 68.2928 36.9346 70.4269 36.1669C71.4513 37.2758 72.5611 38.2994 73.7562 39.1524C73.3294 41.1995 72.9025 43.8438 73.5001 46.0616L77.0001 47.4264C78.7928 46.4881 80.4147 44.0997 81.4391 42.2231C82.2928 42.3937 83.2318 42.3937 84.1708 42.3937C84.7684 42.3937 85.3659 42.3937 85.9635 42.3084C86.9025 44.185 88.3538 46.4028 90.2318 47.7676L93.8172 46.5734C94.5855 44.6968 94.244 41.8819 93.8172 39.6642C95.0976 38.8965 96.2928 37.9582 97.3172 36.8493C99.2806 37.617 101.842 38.3847 104.061 38.2141L106.024 34.9727C105.768 34.2903 105.342 33.6079 104.829 32.9255H93.2196V33.0961Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_42_339",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 72,
    width: 34,
    height: 24
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9756 72.5044C16.817 92.635 33.2927 95.7058 33.2927 95.7058L45.0731 76.4282C45.0731 76.4282 26.2073 81.6314 13.4878 72.9309L12.9756 72.5044Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_42_339)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_42_339",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 71,
    width: 33,
    height: 24
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8415 71.6514H13.7439V94.8528H45.8415V71.6514Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_42_339)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_42_339",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 71,
    width: 33,
    height: 24
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8415 71.6514H13.7439V94.8528H45.8415V71.6514Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_42_339)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_42_339",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 71,
    width: 33,
    height: 24
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8415 71.6514H13.7439V94.7675H45.8415V71.6514Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_42_339)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_42_339",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 71,
    width: 33,
    height: 24
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8415 71.6514H13.7439V94.7675H45.8415V71.6514Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_42_339)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask5_42_339",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 71,
    width: 33,
    height: 24
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8415 71.7363H13.7439V94.8524H45.8415V71.7363Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_42_339)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask6_42_339",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 71,
    width: 33,
    height: 24
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8415 71.7363H13.7439V94.8524H45.8415V71.7363Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_42_339)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask7_42_339",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 71,
    width: 33,
    height: 24
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8415 71.7363H13.7439V94.8524H45.8415V71.7363Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_42_339)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask8_42_339",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 71,
    width: 33,
    height: 24
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8415 71.7363H13.7439V94.8524H45.8415V71.7363Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_42_339)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask9_42_339",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 71,
    width: 33,
    height: 24
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8415 71.7363H13.7439V94.8524H45.8415V71.7363Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_42_339)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask10_42_339",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 71,
    width: 33,
    height: 24
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8415 71.7363H13.7439V94.8524H45.8415V71.7363Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_42_339)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask11_42_339",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 71,
    width: 33,
    height: 24
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8415 71.7363H13.7439V94.8524H45.8415V71.7363Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_42_339)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask12_42_339",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 71,
    width: 33,
    height: 24
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8415 71.7363H13.7439V94.8524H45.8415V71.7363Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_42_339)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask13_42_339",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 71,
    width: 33,
    height: 24
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8415 71.7363H13.7439V94.8524H45.8415V71.7363Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_42_339)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask14_42_339",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 71,
    width: 33,
    height: 24
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8415 71.7363H13.7439V94.8524H45.8415V71.7363Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_42_339)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.8415 71.7363H13.7439V94.8524H45.8415V71.7363Z",
    fill: "url(#paint0_linear_42_339)"
  }))))))))))))))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_42_339",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 33,
    y: 76,
    width: 35,
    height: 21
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2073 95.7056C60.3536 101.591 67.2682 76.2573 67.2682 76.2573C55.6585 85.3843 42.3414 80.9488 42.3414 80.9488L33.2073 95.7056Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_42_339)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask16_42_339",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 32,
    y: 77,
    width: 35,
    height: 27
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3293 77.6221H32.2683V103.041H66.3293V77.6221Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_42_339)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask17_42_339",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 32,
    y: 77,
    width: 35,
    height: 27
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3293 77.6221H32.2683V103.041H66.3293V77.6221Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_42_339)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask18_42_339",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 32,
    y: 77,
    width: 35,
    height: 27
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3293 77.6221H32.2683V103.041H66.3293V77.6221Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_42_339)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask19_42_339",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 32,
    y: 77,
    width: 35,
    height: 27
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3293 77.6221H32.2683V103.041H66.3293V77.6221Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_42_339)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask20_42_339",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 32,
    y: 77,
    width: 35,
    height: 27
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3293 77.6221H32.2683V103.041H66.3293V77.6221Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_42_339)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask21_42_339",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 32,
    y: 77,
    width: 35,
    height: 27
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3293 77.6221H32.2683V103.041H66.3293V77.6221Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_42_339)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask22_42_339",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 32,
    y: 77,
    width: 35,
    height: 27
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3293 77.6221H32.2683V103.041H66.3293V77.6221Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_42_339)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask23_42_339",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 32,
    y: 77,
    width: 35,
    height: 27
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3293 77.6221H32.2683V103.041H66.3293V77.6221Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23_42_339)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask24_42_339",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 32,
    y: 77,
    width: 35,
    height: 27
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3293 77.6221H32.2683V103.041H66.3293V77.6221Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask24_42_339)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask25_42_339",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 32,
    y: 77,
    width: 35,
    height: 27
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3293 77.6221H32.2683V103.041H66.3293V77.6221Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask25_42_339)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask26_42_339",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 32,
    y: 77,
    width: 35,
    height: 27
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3293 77.6221H32.2683V103.041H66.3293V77.6221Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask26_42_339)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask27_42_339",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 32,
    y: 77,
    width: 35,
    height: 27
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3293 77.6221H32.2683V103.041H66.3293V77.6221Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask27_42_339)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask28_42_339",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 32,
    y: 77,
    width: 35,
    height: 27
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3293 77.6221H32.2683V103.041H66.3293V77.6221Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask28_42_339)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask29_42_339",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 32,
    y: 77,
    width: 35,
    height: 27
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3293 77.6221H32.2683V103.041H66.3293V77.6221Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask29_42_339)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.3293 77.6221H32.2683V103.041H66.3293V77.6221Z",
    fill: "url(#paint1_linear_42_339)"
  }))))))))))))))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask30_42_339",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 72,
    width: 33,
    height: 15
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9756 72.5044C13.8292 77.1106 15.4512 80.8637 17.2439 83.8492C21.5975 90.8437 41.8292 83.6786 39.8658 84.7875L44.9878 76.4282C44.9878 76.4282 26.1219 81.6314 13.4024 72.9309L12.9756 72.5044Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask30_42_339)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask31_42_339",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 71,
    width: 33,
    height: 20
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9878 71.8218H12.8903V90.1611H44.9878V71.8218Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask31_42_339)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask32_42_339",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 71,
    width: 33,
    height: 20
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9878 71.8218H12.8903V90.1611H44.9878V71.8218Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask32_42_339)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask33_42_339",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 71,
    width: 33,
    height: 20
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9878 71.8218H12.8903V90.1611H44.9878V71.8218Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask33_42_339)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask34_42_339",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 71,
    width: 33,
    height: 20
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9878 71.8218H12.8903V90.1611H44.9878V71.8218Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask34_42_339)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask35_42_339",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 71,
    width: 33,
    height: 20
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9878 71.8218H12.8903V90.1611H44.9878V71.8218Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask35_42_339)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask36_42_339",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 71,
    width: 33,
    height: 20
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9878 71.8218H12.8903V90.1611H44.9878V71.8218Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask36_42_339)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask37_42_339",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 71,
    width: 33,
    height: 20
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9878 71.8218H12.8903V90.1611H44.9878V71.8218Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask37_42_339)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask38_42_339",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 71,
    width: 33,
    height: 20
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9878 71.8218H12.8903V90.1611H44.9878V71.8218Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask38_42_339)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask39_42_339",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 71,
    width: 33,
    height: 20
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9878 71.8218H12.8903V90.1611H44.9878V71.8218Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask39_42_339)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask40_42_339",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 71,
    width: 33,
    height: 20
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9878 71.8218H12.8903V90.1611H44.9878V71.8218Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask40_42_339)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask41_42_339",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 71,
    width: 33,
    height: 20
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9878 71.8218H12.8903V90.1611H44.9878V71.8218Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask41_42_339)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask42_42_339",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 71,
    width: 33,
    height: 20
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9878 71.8218H12.8903V90.1611H44.9878V71.8218Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask42_42_339)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask43_42_339",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 71,
    width: 33,
    height: 20
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9878 71.8218H12.8903V90.1611H44.9878V71.8218Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask43_42_339)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask44_42_339",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 71,
    width: 33,
    height: 20
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9878 71.8218H12.8903V90.1611H44.9878V71.8218Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask44_42_339)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.9878 71.8218H12.8903V90.1611H44.9878V71.8218Z",
    fill: "url(#paint2_linear_42_339)"
  }))))))))))))))))), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9756 72.5044C13.8292 77.1106 15.4512 80.8637 17.2439 83.8492C21.5975 90.8437 41.8292 83.6786 39.8658 84.7875L44.9878 76.4282C44.9878 76.4282 26.1219 81.6314 13.4024 72.9309L12.9756 72.5044Z",
    stroke: "#C6C6C6",
    strokeWidth: 0.7169
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask45_42_339",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 76,
    width: 31,
    height: 15
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2195 89.1379C37.2195 89.1379 55.4878 93.6587 60.6097 87.9437C65.5609 82.3992 67.2683 76.1724 67.2683 76.1724C55.6585 85.2994 42.3414 80.8638 42.3414 80.8638L37.2195 89.1379Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask45_42_339)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask46_42_339",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 76,
    width: 31,
    height: 19
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1828 76.5986H37.134V94.085H67.1828V76.5986Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask46_42_339)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask47_42_339",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 76,
    width: 31,
    height: 19
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1828 76.5986H37.134V94.085H67.1828V76.5986Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask47_42_339)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask48_42_339",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 76,
    width: 31,
    height: 19
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1828 76.5986H37.134V94.085H67.1828V76.5986Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask48_42_339)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask49_42_339",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 76,
    width: 31,
    height: 19
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1828 76.5986H37.134V94.085H67.1828V76.5986Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask49_42_339)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask50_42_339",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 76,
    width: 31,
    height: 19
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1828 76.5986H37.134V94.085H67.1828V76.5986Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask50_42_339)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask51_42_339",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 76,
    width: 31,
    height: 19
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1828 76.5986H37.134V94.085H67.1828V76.5986Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask51_42_339)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask52_42_339",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 76,
    width: 31,
    height: 19
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1828 76.5986H37.134V94.085H67.1828V76.5986Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask52_42_339)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask53_42_339",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 76,
    width: 31,
    height: 19
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1828 76.5986H37.134V94.085H67.1828V76.5986Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask53_42_339)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask54_42_339",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 76,
    width: 31,
    height: 19
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1828 76.5986H37.134V94.085H67.1828V76.5986Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask54_42_339)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask55_42_339",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 76,
    width: 31,
    height: 19
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1828 76.5986H37.134V94.085H67.1828V76.5986Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask55_42_339)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask56_42_339",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 76,
    width: 31,
    height: 19
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1828 76.5986H37.134V94.085H67.1828V76.5986Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask56_42_339)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask57_42_339",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 76,
    width: 31,
    height: 19
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1828 76.5986H37.134V94.085H67.1828V76.5986Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask57_42_339)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask58_42_339",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 76,
    width: 31,
    height: 19
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1828 76.5986H37.134V94.085H67.1828V76.5986Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask58_42_339)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask59_42_339",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 76,
    width: 31,
    height: 19
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1828 76.5986H37.134V94.085H67.1828V76.5986Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask59_42_339)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.1828 76.5986H37.134V94.085H67.1828V76.5986Z",
    fill: "url(#paint3_linear_42_339)"
  }))))))))))))))))), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2195 89.1379C37.2195 89.1379 55.4878 93.6587 60.6097 87.9437C65.5609 82.3992 67.2683 76.1724 67.2683 76.1724C55.6585 85.2994 42.3414 80.8638 42.3414 80.8638L37.2195 89.1379Z",
    stroke: "#C6C6C6",
    strokeWidth: 0.7169
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask60_42_339",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 79,
    width: 28,
    height: 12
  }, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9391 79.4133C13.4878 78.7309 25.8659 85.8961 41.3171 82.6547L36.7927 89.9904C36.7927 89.9904 22.0244 90.6728 18.3537 85.8961C16.3049 83.2518 14.9391 79.4133 14.9391 79.4133Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask60_42_339)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask61_42_339",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 79,
    width: 29,
    height: 13
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6586 79.1577H13.8293V91.0996H41.6586V79.1577Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask61_42_339)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask62_42_339",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 79,
    width: 29,
    height: 13
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6586 79.1577H13.8293V91.0996H41.6586V79.1577Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask62_42_339)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask63_42_339",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 79,
    width: 29,
    height: 13
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6586 79.1577H13.8293V91.0996H41.6586V79.1577Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask63_42_339)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask64_42_339",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 79,
    width: 29,
    height: 13
  }, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6586 79.1577H13.8293V91.0996H41.6586V79.1577Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask64_42_339)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask65_42_339",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 79,
    width: 29,
    height: 13
  }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6586 79.1577H13.8293V91.0996H41.6586V79.1577Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask65_42_339)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask66_42_339",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 79,
    width: 29,
    height: 13
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6586 79.1577H13.8293V91.0996H41.6586V79.1577Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask66_42_339)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask67_42_339",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 79,
    width: 29,
    height: 13
  }, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6586 79.1577H13.8293V91.0143H41.6586V79.1577Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask67_42_339)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask68_42_339",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 79,
    width: 29,
    height: 13
  }, _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6586 79.2427H13.8293V91.0993H41.6586V79.2427Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask68_42_339)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask69_42_339",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 79,
    width: 29,
    height: 13
  }, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6586 79.2427H13.8293V91.0993H41.6586V79.2427Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask69_42_339)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask70_42_339",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 79,
    width: 29,
    height: 13
  }, _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6586 79.2427H13.8293V91.0993H41.6586V79.2427Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask70_42_339)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask71_42_339",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 79,
    width: 29,
    height: 13
  }, _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6586 79.2427H13.8293V91.0993H41.6586V79.2427Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask71_42_339)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask72_42_339",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 79,
    width: 29,
    height: 13
  }, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6586 79.2427H13.8293V91.0993H41.6586V79.2427Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask72_42_339)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask73_42_339",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 79,
    width: 29,
    height: 13
  }, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6586 79.2427H13.8293V91.0993H41.6586V79.2427Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask73_42_339)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask74_42_339",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 79,
    width: 29,
    height: 13
  }, _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6586 79.2427H13.8293V91.014H41.6586V79.2427Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask74_42_339)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.6586 79.2427H13.8293V91.014H41.6586V79.2427Z",
    fill: "url(#paint4_linear_42_339)"
  }))))))))))))))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask75_42_339",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 36,
    y: 83,
    width: 29,
    height: 10
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5245 85.2994C39.5245 85.2994 49.3416 90.1615 64.1099 83.6787C64.1099 83.6787 59.244 90.332 57.0245 91.185C57.0245 91.185 48.744 95.1941 36.1099 91.0144L39.5245 85.2994Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask75_42_339)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask76_42_339",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 82,
    width: 29,
    height: 13
  }, _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3415 82.8257H35.2561V94.3411H63.3415V82.8257Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask76_42_339)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask77_42_339",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 82,
    width: 29,
    height: 13
  }, _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3415 82.8257H35.2561V94.3411H63.3415V82.8257Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask77_42_339)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask78_42_339",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 82,
    width: 29,
    height: 13
  }, _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3415 82.8257H35.2561V94.3411H63.3415V82.8257Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask78_42_339)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask79_42_339",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 82,
    width: 29,
    height: 13
  }, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3415 82.8257H35.2561V94.3411H63.3415V82.8257Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask79_42_339)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask80_42_339",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 82,
    width: 29,
    height: 13
  }, _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3415 82.8257H35.2561V94.3411H63.3415V82.8257Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask80_42_339)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask81_42_339",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 82,
    width: 29,
    height: 13
  }, _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3415 82.8257H35.2561V94.3411H63.3415V82.8257Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask81_42_339)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask82_42_339",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 82,
    width: 29,
    height: 13
  }, _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3415 82.8257H35.2561V94.3411H63.3415V82.8257Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask82_42_339)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask83_42_339",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 82,
    width: 29,
    height: 13
  }, _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3415 82.8257H35.2561V94.3411H63.3415V82.8257Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask83_42_339)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask84_42_339",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 82,
    width: 29,
    height: 13
  }, _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3415 82.8257H35.2561V94.3411H63.3415V82.8257Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask84_42_339)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask85_42_339",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 82,
    width: 29,
    height: 13
  }, _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3415 82.8257H35.2561V94.3411H63.3415V82.8257Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask85_42_339)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask86_42_339",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 82,
    width: 29,
    height: 13
  }, _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3415 82.8257H35.2561V94.3411H63.3415V82.8257Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask86_42_339)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask87_42_339",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 82,
    width: 29,
    height: 13
  }, _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3415 82.8257H35.2561V94.3411H63.3415V82.8257Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask87_42_339)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask88_42_339",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 82,
    width: 29,
    height: 13
  }, _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3415 82.8257H35.2561V94.3411H63.3415V82.8257Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask88_42_339)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask89_42_339",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 82,
    width: 29,
    height: 13
  }, _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3415 82.8257H35.2561V94.3411H63.3415V82.8257Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask89_42_339)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.3415 82.8257H35.2561V94.3411H63.3415V82.8257Z",
    fill: "url(#paint5_linear_42_339)"
  }))))))))))))))))), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6707 49.9007V50.0713C31.6707 51.0096 31.5 51.6067 31.1585 52.0332C30.817 52.4597 30.2195 52.6302 29.3658 52.6302C28.5122 52.6302 27.8292 52.4597 27.4878 52.0332C27.1463 51.6067 26.9756 50.9243 26.9756 49.9007V47.5123C26.9756 46.4887 27.1463 45.8063 27.4878 45.3798C27.8292 44.9533 28.5122 44.7827 29.3658 44.7827C30.1341 44.7827 30.7317 44.9533 31.0731 45.3798C31.4146 45.721 31.5853 46.3181 31.5853 47.0005V47.1711V47.427H29.9634V47.1711C29.9634 46.7446 29.9634 46.4887 29.7927 46.2328C29.7073 45.8916 29.6219 45.8063 29.3658 45.8063C29.1097 45.8063 28.8536 45.8916 28.6829 46.1475C28.5122 46.4034 28.5122 46.7446 28.5122 47.2564V49.6448C28.5122 50.3272 28.5975 50.7537 28.6829 51.0096C28.7683 51.2655 29.0244 51.4361 29.3658 51.4361C29.6219 51.4361 29.7927 51.3508 29.878 51.0949C29.9634 50.839 30.0488 50.4978 30.0488 50.0713V49.8154H31.6707V49.9007Z",
    fill: "white"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3779 52.033C33.0365 51.6065 32.8657 50.9241 32.8657 49.9858V46.8297C32.8657 46.1473 33.0365 45.5503 33.4633 45.2091C33.8901 44.8679 34.4877 44.6973 35.256 44.6973C36.0243 44.6973 36.6218 44.8679 37.0487 45.2091C37.4755 45.5503 37.6462 46.1473 37.6462 46.8297V49.9858C37.6462 50.9241 37.4755 51.6065 37.134 52.033C36.7926 52.4595 36.1096 52.6301 35.256 52.6301C34.3169 52.6301 33.7194 52.4595 33.3779 52.033ZM35.8535 51.18C35.9389 51.0094 36.0243 50.5829 36.0243 50.0711V46.915C36.0243 46.5739 35.9389 46.318 35.8535 46.1474C35.6828 45.9768 35.5121 45.8915 35.256 45.8915C34.9999 45.8915 34.7438 45.9768 34.6584 46.1474C34.4877 46.318 34.4877 46.5739 34.4877 46.915V50.0711C34.4877 50.5829 34.573 50.9241 34.6584 51.18C34.7438 51.3506 34.9999 51.5212 35.256 51.5212C35.5121 51.4359 35.6828 51.3506 35.8535 51.18Z",
    fill: "white"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0122 44.7824H39.7805H40.5488V47.9385H41.6585V46.7443C41.6585 46.0619 41.8293 45.4648 42.2561 45.1236C42.6829 44.7824 43.2805 44.6118 44.0488 44.6118C44.8171 44.6118 45.4146 44.7824 45.8415 45.1236C46.2683 45.4648 46.439 46.0619 46.439 46.7443V49.9004C46.439 50.7534 46.2683 51.4358 45.8415 51.8623C45.5 52.374 44.9025 52.6299 44.1342 52.6299C43.3659 52.6299 42.7683 52.374 42.3415 51.9476C41.9146 51.5211 41.7439 50.8387 41.7439 49.9857V49.1327H40.6342V52.5447H39.8659H39.0122V44.7824ZM43.4512 46.0619C43.3659 46.2325 43.2805 46.4884 43.2805 46.9149V50.071C43.2805 50.5828 43.3659 50.924 43.4512 51.1799C43.5366 51.3505 43.7927 51.5211 44.0488 51.5211C44.3903 51.5211 44.561 51.4358 44.6464 51.1799C44.7317 51.0093 44.8171 50.5828 44.8171 50.071V46.9149C44.8171 46.4884 44.7317 46.2325 44.6464 46.0619C44.6464 45.8913 44.3903 45.806 44.1342 45.806C43.7927 45.806 43.622 45.8913 43.4512 46.0619Z",
    fill: "white"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3171 52.0332C47.9757 51.6067 47.8049 51.0096 47.8049 50.0713V49.8154H49.4269V50.0713C49.4269 50.4978 49.5122 50.839 49.5976 51.0949C49.7683 51.3508 49.9391 51.4361 50.1952 51.4361C50.5366 51.4361 50.7074 51.3508 50.8781 51.1802C50.9635 51.0096 51.0488 50.6684 51.0488 50.2419V50.0713C51.0488 49.6448 50.9635 49.3889 50.8781 49.3036C50.7927 49.133 50.5366 49.0477 50.1952 49.0477H49.5122V47.8535H50.2805C50.622 47.8535 50.7927 47.7682 50.8781 47.6829C50.9635 47.5123 51.0488 47.2564 51.0488 46.9152V46.7446C51.0488 46.4034 50.9635 46.1475 50.8781 46.0622C50.7927 45.8916 50.5366 45.8916 50.2805 45.8916C50.0244 45.8916 49.8537 45.9769 49.683 46.2328C49.5976 46.4034 49.5122 46.7446 49.5122 47.1711V47.427H47.8903V47.1711C47.8903 46.4034 48.061 45.8063 48.4025 45.3798C48.8293 44.9533 49.4269 44.7827 50.1952 44.7827C50.9635 44.7827 51.561 44.9533 51.9879 45.2092C52.4147 45.4651 52.5854 45.9769 52.5854 46.574V46.6593C52.5854 47.427 52.4147 48.0241 52.0732 48.28C51.9879 48.3653 51.8171 48.4506 51.6464 48.5359C51.8171 48.6212 51.9879 48.7065 52.0732 48.7918C52.4147 49.0477 52.5854 49.5595 52.5854 50.3272V50.4978C52.5854 51.2655 52.4147 51.8626 51.9879 52.2038C51.6464 52.5449 50.9635 52.7155 50.1098 52.7155C49.3415 52.6302 48.6586 52.4597 48.3171 52.0332Z",
    fill: "white"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2561 64.3159H27.5732H26.8903V56.5537H28H29.1098L30.3049 62.4394L31.5 56.5537H32.6098H33.8903V64.3159H33.2073H32.5244V57.8332L31.1586 64.3159H30.3903H29.622L28.2561 57.8332V64.3159Z",
    fill: "white"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7927 56.6392H37.7317H38.6707L40.4634 64.4014H39.6951H38.9268L38.5854 62.7807H36.878L36.5366 64.4014H35.7683H35L36.7927 56.6392ZM37.0488 61.5012H38.3293L37.7317 58.004L37.0488 61.5012Z",
    fill: "white"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5732 64.3159V56.5537H42.3415H43.1098V63.1218H44.6464V56.5537H45.4147H46.183V63.1218H47.7196V56.5537H48.4879H49.2562V64.3159H41.5732Z",
    fill: "white"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9267 64.3159H51.9023H50.8779V56.5537H51.5609H52.2438V61.2452C52.2438 61.5864 52.2438 62.0129 52.2438 62.4394C52.2438 62.8659 52.2438 63.2071 52.2438 63.2924C52.2438 63.1218 52.3291 62.8659 52.4145 62.4394C52.4999 62.0129 52.5852 61.5864 52.6706 61.2452L53.6096 56.5537H54.634H55.6584V64.3159H54.9755H54.2926V59.6245C54.2926 59.2833 54.2926 58.8568 54.2926 58.4303C54.2926 58.0038 54.2926 57.6626 54.2926 57.5773C54.2926 57.7479 54.2072 58.0038 54.1218 58.4303C54.0365 58.8568 53.9511 59.2833 53.8657 59.6245L52.9267 64.3159Z",
    fill: "white"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1099 56.6392H57.8782H58.6465V59.7952H60.0977V56.6392H60.866H61.6343V64.4014H60.866H60.0977V60.9894H58.6465V64.4014H57.8782H57.1099V56.6392Z",
    fill: "white"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7683 63.8894C63.4268 63.463 63.2561 62.7806 63.2561 61.8423V58.6862C63.2561 58.0038 63.4268 57.4067 63.8537 57.0655C64.2805 56.7243 64.8781 56.5537 65.6463 56.5537C66.4146 56.5537 67.0122 56.7243 67.439 57.0655C67.8659 57.4067 68.0366 58.0038 68.0366 58.6862V61.8423C68.0366 62.7806 67.8659 63.463 67.5244 63.8894C67.1829 64.3159 66.5 64.4865 65.6463 64.4865C64.7073 64.4865 64.1098 64.2306 63.7683 63.8894ZM66.2439 63.0365C66.3293 62.8659 66.4146 62.4394 66.4146 61.9276V58.7715C66.4146 58.4303 66.3293 58.1744 66.2439 58.0038C66.0732 57.8332 65.9024 57.7479 65.6463 57.7479C65.3902 57.7479 65.1342 57.8332 65.0488 58.0038C64.8781 58.1744 64.8781 58.4303 64.8781 58.7715V61.9276C64.8781 62.4394 64.9634 62.7806 65.0488 63.0365C65.1342 63.2071 65.3902 63.3777 65.6463 63.3777C65.9024 63.2924 66.1585 63.2071 66.2439 63.0365Z",
    fill: "white"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0123 61.7568V62.0127C74.0123 62.951 73.8415 63.5481 73.5001 63.9746C73.1586 64.4011 72.561 64.5717 71.7074 64.5717C70.8537 64.5717 70.1708 64.4011 69.8293 63.9746C69.4879 63.5481 69.3171 62.8657 69.3171 61.8421V59.4537C69.3171 58.4301 69.4879 57.7477 69.8293 57.3212C70.1708 56.8947 70.8537 56.7241 71.7074 56.7241C72.4757 56.7241 73.0732 56.8947 73.4147 57.3212C73.7562 57.6624 73.9269 58.2595 73.9269 58.9419V59.1125V59.3684H72.3049V59.1125C72.3049 58.686 72.2196 58.4301 72.1342 58.1742C72.0488 58.0036 71.8781 57.833 71.622 57.833C71.3659 57.833 71.1098 57.9183 70.9391 58.1742C70.7684 58.4301 70.7684 58.7713 70.7684 59.2831V61.6715C70.7684 62.3539 70.8537 62.7804 70.9391 63.0363C71.0245 63.2922 71.2806 63.4628 71.622 63.4628C71.8781 63.4628 72.0488 63.3775 72.1342 63.1216C72.2196 62.8657 72.3049 62.5245 72.3049 62.098V61.8421H74.0123V61.7568Z",
    fill: "white"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4877 57.7479H74.8657V57.1508V56.5537H79.8169V57.1508V57.7479H78.195V64.3159H77.4267H76.6584V57.7479H76.4877Z",
    fill: "white"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7561 56.6392H81.5244H83.061C83.9146 56.6392 84.5122 56.8098 84.8537 57.151C85.1951 57.4922 85.3659 58.0893 85.3659 58.9422C85.3659 59.8805 85.1951 60.4776 84.8537 60.8188C84.5122 61.16 83.8293 61.3306 82.7195 61.3306H82.2927V64.4014H81.5244H80.7561V56.6392ZM82.3781 60.1364H82.8049C83.2317 60.1364 83.4878 60.0511 83.6585 59.8805C83.8293 59.7099 83.8293 59.3687 83.8293 58.9422C83.8293 58.5157 83.7439 58.1746 83.5732 58.004C83.4024 57.8334 83.1463 57.7481 82.7195 57.7481H82.2927V60.1364H82.3781Z",
    fill: "white"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M87.1584 63.8894C86.817 63.463 86.6462 62.7806 86.6462 61.8423V58.6862C86.6462 58.0038 86.817 57.4067 87.2438 57.0655C87.6706 56.7243 88.2682 56.5537 89.0365 56.5537C89.8048 56.5537 90.4023 56.7243 90.8292 57.0655C91.256 57.4067 91.4267 58.0038 91.4267 58.6862V61.8423C91.4267 62.7806 91.256 63.463 90.9145 63.8894C90.5731 64.3159 89.8901 64.4865 89.0365 64.4865C88.0975 64.4865 87.4999 64.2306 87.1584 63.8894ZM89.634 63.0365C89.7194 62.8659 89.8048 62.4394 89.8048 61.9276V58.7715C89.8048 58.4303 89.7194 58.1744 89.634 58.0038C89.4633 57.8332 89.2926 57.7479 89.0365 57.7479C88.7804 57.7479 88.6097 57.8332 88.4389 58.0038C88.2682 58.1744 88.2682 58.4303 88.2682 58.7715V61.9276C88.2682 62.4394 88.3536 62.7806 88.4389 63.0365C88.5243 63.2071 88.7804 63.3777 89.0365 63.3777C89.2926 63.2924 89.5487 63.2071 89.634 63.0365Z",
    fill: "white"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M94.9267 64.3159H93.9023H92.8779V56.5537H93.5609H94.2438V61.2452C94.2438 61.5864 94.2438 62.0129 94.2438 62.4394C94.2438 62.8659 94.2438 63.2071 94.2438 63.2924C94.2438 63.1218 94.3292 62.8659 94.4145 62.4394C94.4999 62.0129 94.5852 61.5864 94.6706 61.2452L95.6096 56.5537H96.634H97.6584V64.3159H96.9755H96.2072V59.6245C96.2072 59.2833 96.2072 58.8568 96.2072 58.4303C96.2072 58.0038 96.2072 57.6626 96.2072 57.5773C96.2072 57.7479 96.1218 58.0038 96.0365 58.4303C95.9511 58.8568 95.8657 59.2833 95.7804 59.6245L94.9267 64.3159Z",
    fill: "white"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M100.305 57.7479H98.6829V57.1508V56.5537H103.634V57.1508V57.7479H102.012V64.3159H101.244H100.476V57.7479H100.305Z",
    fill: "white"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M104.658 64.3159V56.5537H108.5V57.1508V57.7479H106.195V59.7951H108.415V60.3922V60.9893H106.195V63.2071H108.5V63.8041V64.4012H104.658V64.3159Z",
    fill: "white"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M112.939 57.7479H111.658V62.3541C111.658 63.1218 111.488 63.6336 111.232 63.9748C110.89 64.3159 110.463 64.4865 109.695 64.4865H109.439V63.1218H109.61C109.78 63.1218 109.951 63.0365 110.037 62.9512C110.122 62.8659 110.122 62.61 110.122 62.3541V56.5537H114.561V64.3159H113.793H113.024V57.7479H112.939Z",
    fill: "white"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M116.012 64.3159V56.5537H119.854V57.1508V57.7479H117.549V59.7951H119.768V60.3922V60.9893H117.549V63.2071H119.854V63.8041V64.4012H116.012V64.3159Z",
    fill: "white"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M123.268 64.3158H122.244H121.219V56.5535H121.902H122.585V61.245C122.585 61.5862 122.585 62.0127 122.585 62.4392C122.585 62.8657 122.585 63.2069 122.585 63.2922C122.585 63.1216 122.671 62.8657 122.756 62.4392C122.841 62.0127 122.927 61.5862 123.012 61.245L123.951 56.5535H124.976H126V64.3158H125.232H124.549V59.6243C124.549 59.2831 124.549 58.8566 124.549 58.4301C124.549 58.0036 124.549 57.6624 124.549 57.5771C124.549 57.7477 124.463 58.0036 124.378 58.4301C124.293 58.8566 124.207 59.2831 124.122 59.6243L123.268 64.3158ZM123.524 56.0417C123.012 56.0417 122.585 55.8711 122.329 55.6152C122.073 55.3593 121.902 54.9328 121.902 54.5063H122.927C122.927 54.7622 122.927 55.0181 123.012 55.1034C123.098 55.1887 123.268 55.274 123.439 55.274C123.61 55.274 123.78 55.1887 123.866 55.1034C123.951 55.0181 123.951 54.7622 123.951 54.5063H124.976C124.976 55.0181 124.805 55.3593 124.549 55.6152C124.463 55.8711 124.037 56.0417 123.524 56.0417Z",
    fill: "white"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9756 68.4956H27.7439H29.2805C30.1341 68.4956 30.7317 68.6662 31.0731 69.0074C31.4146 69.3486 31.5853 69.9457 31.5853 70.7987C31.5853 71.737 31.4146 72.3341 31.0731 72.6753C30.7317 73.0165 30.0488 73.1871 28.939 73.1871H28.5122V76.2578H27.7439H26.9756V68.4956ZM28.5975 71.9929H29.0244C29.4512 71.9929 29.7073 71.9076 29.878 71.737C30.0488 71.5664 30.0488 71.2252 30.0488 70.7987C30.0488 70.3722 29.9634 70.031 29.7927 69.8604C29.6219 69.6898 29.3658 69.6045 28.939 69.6045H28.5122V71.9929H28.5975Z",
    fill: "white"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3779 75.7464C33.0365 75.3199 32.8657 74.6375 32.8657 73.6992V70.5431C32.8657 69.8607 33.0365 69.2636 33.4633 68.9224C33.8901 68.5812 34.4877 68.4106 35.256 68.4106C36.0243 68.4106 36.6218 68.5812 37.0487 68.9224C37.4755 69.2636 37.6462 69.7754 37.6462 70.5431V73.6992C37.6462 74.6375 37.4755 75.3199 37.134 75.7464C36.7926 76.1729 36.1096 76.3435 35.256 76.3435C34.3169 76.3435 33.7194 76.0876 33.3779 75.7464ZM35.8535 74.8081C35.9389 74.6375 36.0243 74.211 36.0243 73.6992V70.5431C36.0243 70.2019 35.9389 69.946 35.8535 69.7754C35.6828 69.6048 35.5121 69.5195 35.256 69.5195C34.9999 69.5195 34.7438 69.6048 34.6584 69.7754C34.4877 69.946 34.4877 70.2019 34.4877 70.5431V73.6992C34.4877 74.211 34.573 74.5522 34.6584 74.8081C34.7438 74.9787 34.9999 75.1493 35.256 75.1493C35.5121 75.1493 35.6828 75.064 35.8535 74.8081Z",
    fill: "white"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6219 73.5283V73.7842C43.6219 74.7225 43.4511 75.3195 43.1097 75.746C42.7682 76.1725 42.1707 76.3431 41.317 76.3431C40.4633 76.3431 39.7804 76.1725 39.439 75.746C39.0975 75.3195 38.9268 74.6372 38.9268 73.6136V71.2252C38.9268 70.2016 39.0975 69.4339 39.439 69.0927C39.7804 68.6662 40.4633 68.4956 41.317 68.4956C42.0853 68.4956 42.6829 68.6662 43.0243 69.0927C43.3658 69.4339 43.5365 70.031 43.5365 70.7134V70.884V71.1399H41.9146V70.884C41.9146 70.4575 41.9146 70.2016 41.7438 69.9457C41.6585 69.7751 41.4877 69.6045 41.2316 69.6045C40.9755 69.6045 40.7194 69.6898 40.6341 69.9457C40.4633 70.2016 40.4633 70.5428 40.4633 71.0546V73.443C40.4633 74.1254 40.5487 74.5519 40.6341 74.8078C40.7194 75.0637 40.9755 75.2342 41.317 75.2342C41.5731 75.2342 41.7438 75.1489 41.8292 74.8931C41.9146 74.6372 41.9999 74.296 41.9999 73.8695V73.6136H43.6219V73.5283Z",
    fill: "white"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4268 73.5283V73.7842C49.4268 74.7225 49.2561 75.3195 48.9146 75.746C48.5732 76.1725 47.9756 76.3431 47.1219 76.3431C46.2683 76.3431 45.5854 76.1725 45.2439 75.746C44.9024 75.3195 44.7317 74.6372 44.7317 73.6136V71.2252C44.7317 70.2016 44.9024 69.4339 45.2439 69.0927C45.5854 68.6662 46.2683 68.4956 47.1219 68.4956C47.8902 68.4956 48.4878 68.6662 48.8293 69.0927C49.1707 69.4339 49.3414 70.031 49.3414 70.7134V70.884V71.1399H47.7195V70.884C47.7195 70.4575 47.6341 70.2016 47.5488 69.9457C47.4634 69.7751 47.2927 69.6045 47.0366 69.6045C46.7805 69.6045 46.5244 69.6898 46.3536 69.9457C46.1829 70.2016 46.1829 70.5428 46.1829 71.0546V73.443C46.1829 74.1254 46.2683 74.5519 46.3536 74.8078C46.439 75.0637 46.6951 75.2342 47.0366 75.2342C47.2927 75.2342 47.4634 75.1489 47.5488 74.8931C47.6341 74.6372 47.7195 74.296 47.7195 73.8695V73.6136H49.4268V73.5283Z",
    fill: "white"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7561 76.1729H51.7317H50.7073V68.4106H51.3902H52.0731V73.1021C52.0731 73.4433 52.0731 73.8698 52.0731 74.2963C52.0731 74.7228 52.0731 75.064 52.0731 75.1493C52.0731 74.9787 52.1585 74.7228 52.2439 74.2963C52.3292 73.8698 52.4146 73.4433 52.5 73.1021L53.439 68.4106H54.4634H55.4878V76.1729H54.8048H54.1219V71.4814C54.1219 71.1402 54.1219 70.7137 54.1219 70.2872C54.1219 69.8607 54.1219 69.5195 54.1219 69.4342C54.1219 69.6048 54.0365 69.8607 53.9512 70.2872C53.8658 70.7137 53.7804 71.1402 53.6951 71.4814L52.7561 76.1729Z",
    fill: "white"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9877 76.1729H57.9634H56.939V68.4106H57.6219H58.3048V73.1021C58.3048 73.4433 58.3048 73.8698 58.3048 74.2963C58.3048 74.7228 58.3048 75.064 58.3048 75.1493C58.3048 74.9787 58.3902 74.7228 58.4756 74.2963C58.5609 73.8698 58.6463 73.4433 58.7316 73.1021L59.6707 68.4106H60.6951H61.7195V76.1729H61.0365H60.3536V71.4814C60.3536 71.1402 60.3536 70.7137 60.3536 70.2872C60.3536 69.8607 60.3536 69.5195 60.3536 69.4342C60.3536 69.6048 60.2682 69.8607 60.1829 70.2872C60.0975 70.7137 60.0121 71.1402 59.9268 71.4814L58.9877 76.1729Z",
    fill: "white"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2073 66.9599C68.2073 67.0452 68.2073 67.1305 68.2073 67.2158C68.2073 82.655 55.7439 95.1087 40.2927 95.1087C24.8415 95.1087 12.378 82.655 12.378 67.2158C12.378 51.7766 24.8415 39.3229 40.2927 39.3229C51.0488 39.3229 60.3537 45.3792 65.0488 54.3356H78.1951L77.1707 51.4354C75.5488 50.8383 73.2439 51.0942 71.2805 51.4354C70.4268 49.8148 69.4878 48.2794 68.4634 46.8293C69.5732 45.3792 70.5976 43.5026 71.0244 41.626L68.5488 38.7258C66.8415 38.8111 64.7927 39.8347 63.0854 40.9436C61.5488 39.5788 59.8415 38.3847 58.0488 37.3611C58.4756 35.5698 58.7317 33.4373 58.3049 31.5607L54.8902 29.94C53.3537 30.7077 51.9024 32.499 50.7927 34.1197C48.7439 33.4373 46.5244 33.0108 44.3049 32.7549C43.9634 30.9636 43.3658 28.9164 42.1707 27.2957L38.3293 27.2104C37.2195 28.5752 36.6219 30.793 36.2805 32.7549C34.2317 33.0108 32.1829 33.4373 30.3049 34.0344C29.2805 32.499 27.9146 30.8783 26.2073 29.8547L22.4512 31.3048C21.939 33.0108 22.2805 35.3139 22.7927 37.2758C21 38.2994 19.378 39.4935 17.8415 40.773C16.3049 39.7494 14.3415 38.8111 12.378 38.5553L9.64634 41.2848C9.81707 43.0761 11.0976 45.038 12.2927 46.6587C11.0976 48.2794 10.0732 49.9854 9.13415 51.7766C7.34146 51.4354 5.12195 51.3501 3.2439 51.8619L1.79268 55.4445C2.64634 56.9799 4.52439 58.3447 6.31707 59.283C5.89024 60.989 5.63415 62.7802 5.46342 64.5715C3.67073 64.998 1.62195 65.6804 0 66.8746V70.7131C1.36585 71.822 3.67073 72.3338 5.63415 72.5897C5.89024 74.2956 6.23171 75.9163 6.7439 77.537C5.20732 78.5606 3.58537 80.0107 2.56098 81.6314L4.0122 85.2139C5.71951 85.7257 8.02439 85.3845 9.98781 84.8728C11.0122 86.5787 12.122 88.1994 13.4024 89.7348C12.378 91.2702 11.439 93.2321 11.1829 95.194L13.9146 97.9235C15.622 97.7529 17.6707 96.5587 19.2927 95.2793C20.6585 96.3028 22.0244 97.2411 23.561 98.0088C23.2195 99.8001 23.0488 101.933 23.4756 103.894L26.9756 105.43C28.5122 104.577 29.878 102.786 30.9878 101.08C32.6098 101.506 34.4024 101.847 36.1098 102.103C36.4512 103.894 37.0488 105.942 38.2439 107.562L42.0854 107.648C43.1951 106.283 43.7927 104.15 44.1341 102.103C45.9268 101.933 47.6341 101.591 49.3415 101.165C50.3659 102.7 51.6463 104.406 53.2683 105.43L56.8537 104.15C57.3659 102.53 57.1097 100.227 56.6829 98.2647C57.9634 97.5823 59.1585 96.8146 60.2683 96.047C61.7195 97.1558 63.5122 98.2647 65.4756 98.6912L68.3781 96.2175C68.2927 94.5116 67.2683 92.4644 66.2439 90.7584C67.5244 89.3083 68.7195 87.6876 69.7439 86.0669C71.5366 86.4934 73.5854 86.8346 75.5488 86.4934L77.2561 83.0815C76.4878 81.5461 74.7805 80.0107 73.1585 78.9018C73.7561 77.2811 74.1829 75.4898 74.439 73.7838C76.2317 73.528 78.2805 73.0161 79.9024 71.9926L80.2439 68.1541C79.9024 67.8982 79.561 67.557 79.1341 67.3864H68.2073V66.9599Z",
    fill: "white"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5977 20.2163V15.7808H80.0733V16.122V16.4632H78.5367V17.4867H78.8781C79.4757 17.4867 79.8172 17.572 80.0733 17.7426C80.244 17.9132 80.4147 18.2544 80.4147 18.7662C80.4147 19.3633 80.3294 19.7045 80.0733 19.8751C79.9025 20.0457 79.4757 20.131 78.8781 20.131H78.1952H77.5977V20.2163ZM78.4513 19.5339H78.7074C78.9635 19.5339 79.1342 19.4486 79.2196 19.3633C79.305 19.278 79.3903 19.1074 79.3903 18.7662C79.3903 18.5103 79.3903 18.3397 79.305 18.2544C79.2196 18.1691 79.0489 18.0838 78.7928 18.0838H78.4513V19.5339Z",
    fill: "white"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M81.7806 15.8662H82.2928H82.805L83.8294 20.3018H83.4025H82.9757L82.805 19.3635H81.8659L81.6952 20.2165H81.2684H80.8416L81.7806 15.8662ZM81.9513 18.5958H82.7196L82.3781 16.6339L81.9513 18.5958Z",
    fill: "white"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5122 20.2163V15.7808H84.939H85.3659V19.5339H86.2195V15.7808H86.6464H87.0732V19.5339H87.9268V15.7808H88.3537H88.7805V20.2163H84.5122Z",
    fill: "white"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8901 15.8662H90.317H90.7438V17.5722C90.9999 17.5722 91.1706 17.4869 91.3414 17.4016C91.4267 17.3163 91.5121 17.1457 91.5121 16.8898V16.7192C91.5121 16.378 91.5975 16.2074 91.7682 16.0368C91.9389 15.8662 92.1096 15.8662 92.4511 15.8662H92.6218V16.6339H92.5365C92.4511 16.6339 92.4511 16.6339 92.3657 16.7192C92.3657 16.8045 92.2804 16.8045 92.2804 16.9751V17.0604C92.2804 17.4016 92.195 17.6575 91.9389 17.8281C91.8536 17.8281 91.8536 17.9134 91.7682 17.9134C91.9389 17.9134 92.0243 17.9987 92.1096 18.084C92.3657 18.2546 92.4511 18.5105 92.5365 18.937L92.6218 19.7047C92.6218 19.8753 92.6218 20.0459 92.7072 20.1312C92.7072 20.2165 92.7926 20.3018 92.7926 20.4724H92.3657H91.9389C91.9389 20.3871 91.8536 20.3018 91.8536 20.2165C91.8536 20.1312 91.8536 19.9606 91.7682 19.8753L91.6828 19.1929C91.6828 18.937 91.5975 18.7664 91.5121 18.6811C91.4267 18.5958 91.256 18.5105 90.9999 18.5105H90.8292V20.2165H90.4023H89.9755V15.8662H89.8901Z",
    fill: "white"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M93.5609 19.9603C93.3902 19.7044 93.2195 19.3632 93.2195 18.7661V16.9748C93.2195 16.5483 93.3048 16.2924 93.5609 16.0365C93.817 15.8659 94.1585 15.6953 94.5853 15.6953C95.0122 15.6953 95.3536 15.7806 95.6097 16.0365C95.8658 16.2071 95.9512 16.5483 95.9512 16.9748V18.7661C95.9512 19.2779 95.8658 19.7044 95.6097 19.9603C95.439 20.2162 95.0122 20.3015 94.5853 20.3015C94.0731 20.3015 93.7317 20.2162 93.5609 19.9603ZM95.0122 19.4485C95.0975 19.3632 95.0975 19.1073 95.0975 18.8514V17.0601C95.0975 16.8895 95.0975 16.7189 95.0122 16.6336C94.9268 16.5483 94.8414 16.463 94.6707 16.463C94.5 16.463 94.4146 16.5483 94.3292 16.6336C94.2439 16.7189 94.2439 16.8895 94.2439 17.0601V18.8514C94.2439 19.1073 94.2439 19.3632 94.3292 19.4485C94.4146 19.5338 94.5 19.6191 94.6707 19.6191C94.7561 19.6191 94.9268 19.6191 95.0122 19.4485Z",
    fill: "white"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8049 15.8662H97.2318H98.0854C98.5976 15.8662 98.9391 15.9515 99.1098 16.2074C99.2805 16.378 99.4513 16.7192 99.4513 17.231C99.4513 17.7428 99.3659 18.084 99.1098 18.3399C98.9391 18.5105 98.5123 18.5958 97.9147 18.5958H97.6586V20.2165H97.2318H96.8049V15.8662ZM97.6586 17.8281H97.9147C98.1708 17.8281 98.3415 17.7428 98.4269 17.6575C98.5123 17.5722 98.5122 17.4016 98.5122 17.1457C98.5122 16.8898 98.5123 16.7192 98.4269 16.6339C98.3415 16.5486 98.1708 16.4633 97.9147 16.4633H97.6586V17.8281Z",
    fill: "white"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M100.817 16.4632H99.8782V16.122V15.7808H102.695V16.122V16.4632H101.756V20.2163H101.329H100.903V16.4632H100.817Z",
    fill: "white"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M103.549 19.9603C103.378 19.7044 103.207 19.3632 103.207 18.7661V16.9748C103.207 16.5483 103.293 16.2924 103.549 16.0365C103.805 15.8659 104.146 15.6953 104.573 15.6953C105 15.6953 105.341 15.7806 105.598 16.0365C105.854 16.2071 105.939 16.5483 105.939 16.9748V18.7661C105.939 19.2779 105.854 19.7044 105.598 19.9603C105.427 20.2162 105 20.3015 104.573 20.3015C104.146 20.3015 103.805 20.2162 103.549 19.9603ZM105 19.4485C105.085 19.3632 105.085 19.1073 105.085 18.8514V17.0601C105.085 16.8895 105.085 16.7189 105 16.6336C104.915 16.5483 104.829 16.463 104.658 16.463C104.488 16.463 104.402 16.5483 104.317 16.6336C104.232 16.7189 104.232 16.8895 104.232 17.0601V18.8514C104.232 19.1073 104.232 19.3632 104.317 19.4485C104.402 19.5338 104.488 19.6191 104.658 19.6191C104.829 19.6191 104.915 19.6191 105 19.4485Z",
    fill: "white"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M109.439 18.766V18.9366C109.439 19.4484 109.354 19.7896 109.183 20.0455C109.012 20.3014 108.671 20.3867 108.158 20.3867C107.646 20.3867 107.305 20.3014 107.049 20.0455C106.878 19.7896 106.707 19.3631 106.707 18.8513V17.4866C106.707 16.8895 106.793 16.463 107.049 16.2924C107.219 16.0365 107.646 15.9512 108.158 15.9512C108.585 15.9512 108.927 16.0365 109.098 16.2924C109.268 16.463 109.439 16.8042 109.354 17.2307V17.316V17.4866H108.415V17.316C108.415 17.0601 108.415 16.8895 108.329 16.8042C108.244 16.7189 108.158 16.6336 108.073 16.6336C107.902 16.6336 107.817 16.7189 107.732 16.8042C107.646 16.9748 107.646 17.1454 107.646 17.4013V18.766C107.646 19.1072 107.646 19.4484 107.732 19.5337C107.817 19.7043 107.902 19.7896 108.073 19.7896C108.244 19.7896 108.329 19.7043 108.415 19.619C108.5 19.4484 108.5 19.2778 108.5 19.0219V18.8513H109.439V18.766Z",
    fill: "white"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M110.89 16.4632H109.951V16.122V15.7808H112.768V16.122V16.4632H111.829V20.2163H111.402H110.976V16.4632H110.89Z",
    fill: "white"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M114.134 15.8662H114.646H115.158L116.183 20.3018H115.756H115.329L115.158 19.3635H114.219L114.049 20.3018H113.622H113.195L114.134 15.8662ZM114.305 18.5958H114.988L114.646 16.6339L114.305 18.5958Z",
    fill: "white"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M116.866 15.8662H117.293H117.719V17.6575H118.573V15.8662H119H119.427V20.2165H119H118.573V18.2546H117.719V20.2165H117.293H116.866V15.8662Z",
    fill: "white"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M123.012 18.766V18.9366C123.012 19.4484 122.927 19.7896 122.756 20.0455C122.585 20.3014 122.244 20.3867 121.732 20.3867C121.22 20.3867 120.878 20.3014 120.622 20.0455C120.451 19.7896 120.281 19.3631 120.281 18.8513V17.4866C120.281 16.8895 120.366 16.463 120.622 16.2924C120.793 16.0365 121.22 15.9512 121.732 15.9512C122.159 15.9512 122.5 16.0365 122.671 16.2924C122.841 16.463 123.012 16.8042 122.927 17.2307V17.316V17.4866H121.988V17.316C121.988 17.0601 121.988 16.8895 121.902 16.8042C121.817 16.7189 121.732 16.6336 121.646 16.6336C121.476 16.6336 121.39 16.7189 121.305 16.8042C121.22 16.9748 121.22 17.1454 121.22 17.4013V18.766C121.22 19.1072 121.22 19.4484 121.305 19.5337C121.39 19.7043 121.476 19.7896 121.646 19.7896C121.817 19.7896 121.902 19.7043 121.988 19.619C122.073 19.4484 122.073 19.2778 122.073 19.0219V18.8513H123.012V18.766Z",
    fill: "white"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M123.781 15.8662H124.207H124.634V17.5722C124.89 17.5722 125.061 17.4869 125.232 17.4016C125.317 17.3163 125.402 17.1457 125.402 16.8898V16.7192C125.402 16.378 125.488 16.2074 125.659 16.0368C125.829 15.8662 126 15.8662 126.341 15.8662H126.512V16.6339H126.427C126.341 16.6339 126.341 16.6339 126.256 16.7192C126.256 16.8045 126.171 16.8045 126.171 16.9751V17.0604C126.171 17.4016 126.085 17.6575 125.829 17.8281C125.744 17.8281 125.744 17.9134 125.659 17.9134C125.829 17.9134 125.915 17.9987 126 18.084C126.256 18.2546 126.341 18.5105 126.427 18.937L126.512 19.7047C126.512 19.8753 126.512 20.0459 126.598 20.1312C126.598 20.2165 126.683 20.3018 126.683 20.4724H126.256H125.829C125.829 20.3871 125.744 20.3018 125.744 20.2165C125.744 20.1312 125.744 19.9606 125.659 19.8753L125.573 19.1929C125.573 18.937 125.488 18.7664 125.402 18.6811C125.317 18.5958 125.146 18.5105 124.89 18.5105H124.72V20.2165H124.293H123.866V15.8662H123.781Z",
    fill: "white"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M127.451 19.9603C127.281 19.7044 127.11 19.3632 127.11 18.7661V16.9748C127.11 16.5483 127.195 16.2924 127.451 16.0365C127.707 15.8659 128.049 15.6953 128.476 15.6953C128.903 15.6953 129.244 15.7806 129.5 16.0365C129.756 16.2071 129.842 16.5483 129.842 16.9748V18.7661C129.842 19.2779 129.756 19.7044 129.5 19.9603C129.329 20.2162 128.903 20.3015 128.476 20.3015C127.964 20.3015 127.622 20.2162 127.451 19.9603ZM128.903 19.4485C128.988 19.3632 128.988 19.1073 128.988 18.8514V17.0601C128.988 16.8895 128.988 16.7189 128.903 16.6336C128.817 16.5483 128.732 16.463 128.561 16.463C128.39 16.463 128.305 16.5483 128.22 16.6336C128.134 16.7189 128.134 16.8895 128.134 17.0601V18.8514C128.134 19.1073 128.134 19.3632 128.22 19.4485C128.305 19.5338 128.39 19.6191 128.561 19.6191C128.646 19.6191 128.817 19.6191 128.903 19.4485Z",
    fill: "white"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M130.695 20.2163V15.7808H132.915V16.122V16.4632H131.634V17.6573H132.915V17.9985V18.3397H131.634V19.6192H133V19.9604V20.2163H130.695Z",
    fill: "white"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5122 21.4106H77.939H78.7927C79.3049 21.4106 79.6464 21.4959 79.8171 21.7518C79.9878 21.9224 80.1585 22.2636 80.1585 22.7754C80.1585 23.2872 80.0732 23.6284 79.8171 23.8843C79.6464 24.0549 79.2195 24.1402 78.622 24.1402H78.3659V25.9315H77.939H77.5122V21.4106ZM78.4512 23.3725H78.7073C78.9634 23.3725 79.1342 23.2872 79.2195 23.2019C79.3049 23.1166 79.3049 22.946 79.3049 22.6901C79.3049 22.4342 79.2195 22.2636 79.2195 22.1783C79.1342 22.093 78.9634 22.0077 78.7073 22.0077H78.4512V23.3725Z",
    fill: "white"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8416 25.7608V21.3252H83.0611V21.6664V22.0076H81.7806V23.2018H83.0611V23.543V23.8842H81.7806V25.1637H83.1464V25.5049V25.8461H80.8416V25.7608Z",
    fill: "white"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7684 25.7608H84.2562H83.8293V21.3252H86.1342V21.6664V22.0076H84.7684V25.7608Z",
    fill: "white"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0123 25.7606H87.4147H86.8171V21.325H87.1586H87.5001V23.9693C87.5001 24.1399 87.5001 24.3958 87.5001 24.6517C87.5001 24.9076 87.5001 25.0782 87.5001 25.1635C87.5001 25.0782 87.5001 24.9076 87.5854 24.6517C87.6708 24.3958 87.6708 24.1399 87.7562 23.9693L88.2684 21.2397H88.8659H89.4635V25.6753H89.122H88.7806V23.031C88.7806 22.8604 88.7806 22.6045 88.7806 22.3486C88.7806 22.0927 88.7806 21.9221 88.7806 21.8368C88.7806 21.9221 88.7806 22.0927 88.6952 22.3486C88.6098 22.6045 88.6098 22.8604 88.5245 23.031L88.0123 25.7606Z",
    fill: "white"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6586 25.5047C90.4879 25.2488 90.3171 24.9076 90.3171 24.3105V22.5192C90.3171 22.0927 90.4025 21.8368 90.6586 21.5809C90.9147 21.4103 91.2562 21.2397 91.683 21.2397C92.1098 21.2397 92.4513 21.325 92.7074 21.5809C92.9635 21.7515 93.0488 22.0927 93.0488 22.5192V24.3105C93.0488 24.8223 92.9635 25.2488 92.7074 25.5047C92.5367 25.7606 92.1098 25.8459 91.683 25.8459C91.2562 25.8459 90.8293 25.7606 90.6586 25.5047ZM92.1098 24.9929C92.1952 24.9076 92.1952 24.6517 92.1952 24.3958V22.6045C92.1952 22.4339 92.1952 22.2633 92.1098 22.178C92.0245 22.0927 91.9391 22.0074 91.7684 22.0074C91.5976 22.0074 91.5123 22.0927 91.4269 22.178C91.3415 22.2633 91.3415 22.4339 91.3415 22.6045V24.3958C91.3415 24.6517 91.3415 24.9076 91.4269 24.9929C91.5123 25.0782 91.5976 25.1635 91.7684 25.1635C91.9391 25.1635 92.0245 25.1635 92.1098 24.9929Z",
    fill: "white"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M93.9023 21.4106H94.3292H94.756V23.2019H95.6097V21.4106H96.0365H96.4633V25.8462H96.0365H95.6097V23.8843H94.756V25.8462H94.3292H93.9023V21.4106Z",
    fill: "white"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2562 21.4106H98.7684H99.2806L100.305 25.8462H99.8781H99.4513L99.2806 24.9079H98.3415L98.1708 25.8462H97.744H97.3171L98.2562 21.4106ZM98.4269 24.1402H99.1098L98.7684 22.1783L98.4269 24.1402Z",
    fill: "white"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M102.78 22.0076H102.012V24.6519C102.012 25.0784 101.927 25.3343 101.756 25.5902C101.585 25.7608 101.329 25.8461 100.902 25.8461H100.732V25.0784H100.817C100.902 25.0784 100.988 25.0784 101.073 24.9931C101.159 24.9078 101.159 24.8225 101.159 24.6519V21.3252H103.719V25.7608H103.293H102.866V22.0076H102.78Z",
    fill: "white"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M104.573 21.4106H105H105.427V23.1166H105.768C106.366 23.1166 106.707 23.2019 106.963 23.3725C107.134 23.5431 107.305 23.8843 107.305 24.3961C107.305 24.9932 107.22 25.3344 106.963 25.505C106.793 25.6756 106.366 25.7609 105.768 25.7609H105.085H104.659V21.4106H104.573ZM105.427 25.0785H105.683C105.939 25.0785 106.11 24.9932 106.195 24.9079C106.281 24.8226 106.366 24.652 106.366 24.3108C106.366 24.0549 106.366 23.8843 106.281 23.799C106.195 23.7137 106.024 23.6284 105.768 23.6284H105.427V25.0785Z",
    fill: "white"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M107.988 21.4106H108.415H108.841V23.2019H109.695V21.4106H110.122H110.549V25.8462H110.122H109.695V23.8843H108.841V25.8462H108.415H107.988V21.4106Z",
    fill: "white"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M111.829 25.5047C111.659 25.2488 111.488 24.9076 111.488 24.3105V22.5192C111.488 22.0927 111.573 21.8368 111.829 21.5809C112.085 21.4103 112.427 21.2397 112.854 21.2397C113.28 21.2397 113.622 21.325 113.878 21.5809C114.134 21.7515 114.22 22.0927 114.22 22.5192V24.3105C114.22 24.8223 114.134 25.2488 113.878 25.5047C113.707 25.7606 113.28 25.8459 112.854 25.8459C112.341 25.8459 112 25.7606 111.829 25.5047ZM113.195 24.9929C113.28 24.9076 113.28 24.6517 113.28 24.3958V22.6045C113.28 22.4339 113.28 22.2633 113.195 22.178C113.11 22.0927 113.024 22.0074 112.854 22.0074C112.683 22.0074 112.598 22.0927 112.512 22.178C112.427 22.2633 112.427 22.4339 112.427 22.6045V24.3958C112.427 24.6517 112.427 24.9076 112.512 24.9929C112.598 25.0782 112.683 25.1635 112.854 25.1635C113.024 25.1635 113.195 25.1635 113.195 24.9929Z",
    fill: "white"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M115.073 25.7608V21.3252H117.293V21.6664V22.0076H116.012V23.2018H117.293V23.543V23.8842H116.012V25.1637H117.378V25.5049V25.8461H115.073V25.7608Z",
    fill: "white"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8537 31.0491C77.6829 30.7932 77.5122 30.452 77.5122 29.855V28.0637C77.5122 27.6372 77.5976 27.3813 77.8537 27.1254C78.1098 26.9548 78.4512 26.7842 78.8781 26.7842C79.3049 26.7842 79.6464 26.8695 79.9025 27.1254C80.1586 27.296 80.2439 27.6372 80.2439 28.0637V29.855C80.2439 30.3667 80.1586 30.7932 79.9025 31.0491C79.7317 31.305 79.3049 31.3903 78.8781 31.3903C78.4512 31.3903 78.0244 31.305 77.8537 31.0491ZM79.3049 30.5373C79.3903 30.452 79.3903 30.1962 79.3903 29.9403V28.149C79.3903 27.9784 79.3903 27.8078 79.3049 27.7225C79.2195 27.6372 79.1342 27.5519 78.9634 27.5519C78.7927 27.5519 78.7073 27.6372 78.622 27.7225C78.5366 27.8078 78.5366 27.9784 78.5366 28.149V29.9403C78.5366 30.1962 78.5366 30.452 78.622 30.5373C78.7073 30.6226 78.7927 30.7079 78.9634 30.7079C79.1342 30.7079 79.2195 30.7079 79.3049 30.5373Z",
    fill: "white"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8659 27.552H80.8416V27.2108V26.8696H83.6586V27.2108V27.552H82.7196V31.3052H82.2928H81.8659V27.552Z",
    fill: "white"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7684 26.9546H87.244V30.7078H87.6708V32.2431H86.8172V31.3049H85.0245V32.2431H84.0854V30.7078H84.5123C84.5123 30.5372 84.5976 30.2813 84.5976 30.0254C84.683 29.0871 84.7684 28.0635 84.7684 26.9546ZM86.3903 27.5517H85.622C85.622 28.49 85.5367 29.2577 85.4513 29.9401C85.4513 30.196 85.3659 30.4519 85.3659 30.6225H86.3903V27.5517Z",
    fill: "white"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1829 31.3052V26.8696H90.4024V27.2108V27.552H89.1219V28.7462H90.4024V29.0874V29.4286H89.1219V30.7081H90.4877V31.0493V31.3052H88.1829Z",
    fill: "white"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9633 27.552H92.195V30.1963C92.195 30.6228 92.1097 30.8787 91.9389 31.1346C91.7682 31.3052 91.5121 31.3905 91.0853 31.3905H90.9146V30.6228H90.9999C91.0853 30.6228 91.1706 30.6228 91.256 30.5375C91.3414 30.4522 91.3414 30.3669 91.3414 30.1963V26.8696H93.9024V31.3052H93.4755H93.0487V27.552H92.9633Z",
    fill: "white"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6707 31.3052V26.8696H96.8902V27.2108V27.552H95.6097V28.7462H96.8902V29.0874V29.4286H95.6097V30.7081H96.9755V31.0493V31.3052H94.6707Z",
    fill: "white"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6584 26.9546H98.0853H98.5121V28.7459H99.3658V26.9546H99.7926H100.219V31.3049H99.7926H99.3658V29.343H98.5121V31.3049H98.0853H97.6584V26.9546Z",
    fill: "white"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M102.354 31.3052H101.756H101.158V26.8696H101.5H101.841V29.5992C101.841 29.7698 101.841 30.0257 101.841 30.2816C101.841 30.5375 101.841 30.7081 101.841 30.7934C101.841 30.7081 101.841 30.5375 101.927 30.2816C102.012 30.0257 102.012 29.7698 102.097 29.5992L102.61 26.8696H103.207H103.805V31.3052H103.463H103.122V28.6609C103.122 28.4903 103.122 28.2344 103.122 27.9785C103.122 27.7226 103.122 27.552 103.122 27.4667C103.122 27.552 103.122 27.7226 103.036 27.9785C102.951 28.2344 102.951 28.4903 102.866 28.6609L102.354 31.3052Z",
    fill: "white"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M104.744 31.3052V26.8696H106.963V27.2108V27.552H105.598V28.7462H106.878V29.0874V29.4286H105.598V30.7081H106.963V31.0493V31.3052H104.744Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_42_339",
    x1: 13.7438,
    y1: 83.2605,
    x2: 45.8143,
    y2: 83.2605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE0F0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6461,
    stopColor: "#E30613"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E30613"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_42_339",
    x1: 32.2733,
    y1: 87.7753,
    x2: 66.3273,
    y2: 87.7753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE0F0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6461,
    stopColor: "#E30613"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E30613"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_42_339",
    x1: 12.8902,
    y1: 79.0324,
    x2: 44.9607,
    y2: 79.0324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6461,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_42_339",
    x1: 37.1155,
    y1: 83.934,
    x2: 67.1543,
    y2: 83.934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6461,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_42_339",
    x1: 15.2099,
    y1: 85.0819,
    x2: 41.7179,
    y2: 85.0819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#123274"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00562,
    stopColor: "#123274"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5169,
    stopColor: "#164194"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#164194"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_42_339",
    x1: 35.2259,
    y1: 87.4822,
    x2: 63.2978,
    y2: 87.4822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#123274"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00562,
    stopColor: "#123274"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5169,
    stopColor: "#164194"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#164194"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.f1f8b97e7101db7521a66bb5cb61cbef.svg";
export { ForwardRef as ReactComponent };